import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../../../services/user-services/user.service';
import { NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'app-accom-filter-ph',
    templateUrl: './accom-filter-ph.component.html',
    styleUrls: ['./accom-filter-ph.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass]
})
export class AccomFilterPhComponent implements OnInit {

  public isMobile: boolean = false;

  constructor(
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
  }

}
